<template>
  <div>
    <svg
      :viewBox="`0 0 ${w} ${h}`"
      preserveAspectRatio="none"
      :style="{ width: '100%', height: h + 'px', display: 'block' }"
    >
      <!-- pita band: merah di atas, kuning di tengah, hijau di bawah -->
      <rect x="0" y="0" :width="w" :height="yFor(red)" fill="#FFEBEE"></rect>
      <rect
        x="0"
        :y="yFor(red)"
        :width="w"
        :height="yFor(yellow) - yFor(red)"
        fill="#FFF8E1"
      ></rect>
      <rect x="0" :y="yFor(yellow)" :width="w" :height="h - yFor(yellow)" fill="#E8F5E9"></rect>
      <line
        x1="0"
        :y1="yFor(red)"
        :x2="w"
        :y2="yFor(red)"
        stroke="#E53935"
        stroke-dasharray="4 3"
      ></line>
      <line
        x1="0"
        :y1="yFor(yellow)"
        :x2="w"
        :y2="yFor(yellow)"
        stroke="#FB8C00"
        stroke-dasharray="4 3"
      ></line>
      <text x="4" :y="yFor(red) - 4" font-size="10" fill="#B71C1C">{{ red }} %</text>
      <text x="4" :y="yFor(yellow) - 4" font-size="10" fill="#8D6E00">{{ yellow }} %</text>
      <polyline
        v-if="secondaryPoints"
        :points="secondaryPoints"
        fill="none"
        stroke="#90A4AE"
        stroke-width="1.5"
      ></polyline>
      <polyline
        v-if="points"
        :points="points"
        fill="none"
        stroke="#1976D2"
        stroke-width="2.5"
      ></polyline>
      <circle v-if="last" :cx="last.x" :cy="last.y" r="4" fill="#1976D2"></circle>
      <text
        v-if="last"
        :x="Math.min(last.x, w - 4)"
        :y="Math.max(last.y - 8, 10)"
        font-size="11"
        fill="#1976D2"
        text-anchor="end"
      >
        {{ formatPct(last.pct) }}
      </text>
    </svg>
    <div class="bm-tiny d-flex flex-wrap mt-2" style="gap: 16px">
      <span><span class="bm-legend" style="background: #1976d2"></span>Pemakaian / budget</span>
      <span v-if="secondaryPoints"
        ><span class="bm-legend" style="background: #90a4ae"></span>Belanja PO saja</span
      >
      <span v-if="!history.length" class="grey--text">Belum ada riwayat perhitungan.</span>
    </div>
  </div>
</template>

<script>
import { formatPct, trendPoints, yFor } from "@/utils/budgetMonitor";

/** Ratio over time on a red / yellow / green background; each point is one calculation. */
export default {
  name: "budget-trend-chart",
  props: {
    /** ascending HistoryPointDto[] */
    history: { type: Array, default: () => [] },
    yellow: { type: Number, default: 80 },
    red: { type: Number, default: 100 },
    height: { type: Number, default: 130 },
    /** also draw spend-only ratio (belanja PO / budget) */
    showSpend: { type: Boolean, default: true },
  },
  data: () => ({ w: 440 }),
  computed: {
    h() {
      return this.height;
    },
    max() {
      const top = this.history.reduce((m, p) => Math.max(m, Number(p.ratioPercent) || 0), 0);
      return Math.min(300, Math.max(this.red + 20, Math.ceil(top / 10) * 10 + 10));
    },
    points() {
      return trendPoints(this.history, this.w, this.h, this.max);
    },
    secondaryPoints() {
      if (!this.showSpend) return "";
      const rows = this.history.map(p => ({
        ratioPercent:
          Number(p.budgetIdr) > 0 ? (Number(p.spendIdr) / Number(p.budgetIdr)) * 100 : null,
      }));
      return trendPoints(rows, this.w, this.h, this.max);
    },
    last() {
      const rows = this.history.filter(
        p => p && p.ratioPercent !== null && p.ratioPercent !== undefined
      );
      if (!rows.length) return null;
      const pct = Number(rows[rows.length - 1].ratioPercent);
      const x = rows.length === 1 ? this.w / 2 : this.w;
      return { x, y: yFor(pct, this.h, this.max), pct };
    },
  },
  methods: {
    formatPct,
    yFor(pct) {
      return yFor(pct, this.h, this.max);
    },
  },
};
</script>

<style scoped>
.bm-legend {
  display: inline-block;
  width: 14px;
  height: 3px;
  vertical-align: middle;
  margin-right: 6px;
}
</style>
